/* eslint-disable eqeqeq */
import { isString } from 'lodash';
import GraphemeSplitter from 'grapheme-splitter';

const splitterStr = new GraphemeSplitter();

export const GSM_CHARSET_7BIT = 0;
export const GSM_CHARSET_UNICODE = 2;
export const GSM_7BIT_ESC = '\u001b';

export const GSM7BIT = [
  '@',
  '£',
  '$',
  '¥',
  'è',
  'é',
  'ù',
  'ì',
  'ò',
  'Ç',
  '\n',
  'Ø',
  'ø',
  '\r',
  'Å',
  'å',
  'Δ',
  '_',
  'Φ',
  'Γ',
  'Λ',
  'Ω',
  'Π',
  'Ψ',
  'Σ',
  'Θ',
  'Ξ',
  '\u001b',
  'Æ',
  'æ',
  'ß',
  'É',
  ' ',
  '!',
  "'",
  '#',
  '¤',
  '%',
  '&',
  '"',
  '(',
  ')',
  '*',
  '+',
  ',',
  '-',
  '.',
  '/',
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  ':',
  ';',
  '<',
  '=',
  '>',
  '?',
  '¡',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
  'Ä',
  'Ö',
  'Ñ',
  'Ü',
  '§',
  '¿',
  'a',
  'b',
  'c',
  'd',
  'e',
  'f',
  'g',
  'h',
  'i',
  'j',
  'k',
  'l',
  'm',
  'n',
  'o',
  'p',
  'q',
  'r',
  's',
  't',
  'u',
  'v',
  'w',
  'x',
  'y',
  'z',
  'ä',
  'ö',
  'ñ',
  'ü',
  'à',
  '@',
  'Δ',
  ' ',
  '0',
  '¡',
  'P',
  '¿',
  'p',
  '£',
  '_',
  '!',
  '1',
  'A',
  'Q',
  'a',
  'q',
  '$',
  'Φ',
  '"',
  '2',
  'B',
  'R',
  'b',
  'r',
  '¥',
  'Γ',
  '#',
  '3',
  'C',
  'S',
  'c',
  's',
  'è',
  'Λ',
  '¤',
  '4',
  'D',
  'T',
  'd',
  't',
  'é',
  'Ω',
  '%',
  '5',
  'E',
  'U',
  'e',
  'u',
  'ù',
  'Π',
  '&',
  '6',
  'F',
  'V',
  'f',
  'v',
  'ì',
  'Ψ',
  "'",
  '7',
  'G',
  'W',
  'g',
  'w',
  'ò',
  'Σ',
  '(',
  '8',
  'H',
  'X',
  'h',
  'x',
  'Ç',
  'Θ',
  ')',
  '9',
  'I',
  'Y',
  'i',
  'y',
  '\n',
  'Ξ',
  '*',
  ':',
  'J',
  'Z',
  'j',
  'z',
  'Ø',
  '\x1B',
  '+',
  ';',
  'K',
  'Ä',
  'k',
  'ä',
  'ø',
  'Æ',
  ',',
  '<',
  'L',
  'Ö',
  'l',
  'ö',
  '\r',
  'æ',
  '-',
  '=',
  'M',
  'Ñ',
  'm',
  'ñ',
  'Å',
  'ß',
  '.',
  '>',
  'N',
  'Ü',
  'n',
  'ü',
  'å',
  'É',
  '/',
  '?',
  'O',
  '§',
  'o',
  'à',
];

export const GSM7BITEXT = ['\f', '^', '{', '}', '\\', '[', '~', ']', '|', '€'];

export const checkIfUnicode = (char = '') => {
  if (GSM7BIT.indexOf(char) === -1) {
    return true;
  }

  return false;
};

export const getCharset = (content) => {
  for (const c of content) {
    if (!GSM7BIT.includes(c) && !GSM7BITEXT.includes(c)) return GSM_CHARSET_UNICODE;
  }

  return GSM_CHARSET_7BIT;
};

const getPartCount7bit = (content) => {
  let content7bit = '';

  for (let i = 0; i < content.length; i++) {
    let c = content.charAt(i);
    if (!GSM7BITEXT.includes(c)) {
      content7bit += c;
    } else {
      content7bit += GSM_7BIT_ESC + c;
    }
  }

  if (content7bit.length <= 160) {
    return 1;
  } else {
    let parts = Math.ceil(content7bit.length / 153.0);
    let free_chars = content7bit.length - Math.floor(content7bit.length / 153.0) * 153;

    if (free_chars >= parts - 1) {
      return parts;
    }

    parts = 0;
    while (content7bit.length > 0) {
      // Advance sms counter
      parts++;

      // Check for trailing escape character
      if (content7bit.length >= 152 && content7bit.charAt(152) == GSM_7BIT_ESC) {
        content7bit = content7bit.replace(content7bit.substr(0, 152), '');
      } else {
        content7bit = content7bit.replace(content7bit.substr(0, 153), '');
      }
    }

    return parts;
  }
};

export const getPartCount = (content) => {
  let charset = getCharset(content);

  if (charset == GSM_CHARSET_7BIT) {
    return getPartCount7bit(content);
  } else if (charset == GSM_CHARSET_UNICODE) {
    if (content.length <= 70) {
      return 1;
    } else {
      return Math.ceil(content.length / 67.0);
    }
  }

  return -1;
};

export const getPartCountMMS = (content) => {
  return Math.ceil(content.length / 1600.0);
};

//! Function counter sms
const exceptionChar = ['[', ']', '{', '}', '|'];
export const renderCharWithHighlight = (content = '') => {
  let string = '';
  if (isString(content)) {
    const contentSplit = splitterStr.splitGraphemes(content);
    contentSplit.forEach((char) => {
      if (char !== '€' && checkIfUnicode(char)) {
        string = string + `<span class="highlight-text">${char}</span>`;
      } else {
        string = string + char;
      }
    });

    return string;
  }

  return string;
};

export const highlightUnicodeChar = (content) => {
  if (isString(content)) {
    let tempArr = [];

    const contentSplit = splitterStr.splitGraphemes(content);
    contentSplit.forEach((char) => {
      if (char !== '€' && checkIfUnicode(char) && !exceptionChar.includes(char)) {
        tempArr = [
          ...tempArr,
          {
            highlight: char,
            className: 'color-highlight-text',
          },
        ];
      }
    });

    return tempArr;
  }

  return [];
};

export const smsCounter = (content) => {
  let cutStrLength = 0;
  const s = {
    cut: true,
    maxSmsNum: 7,
    lengths: {
      // detail in https://www.world-text.com/docs/sms-length.php
      ascii: [160, 306, 459, 612, 765, 918, 1071, 1224, 1377],
      unicode: [70, 134, 201, 268, 335, 402, 469, 536, 603],
    },
  };

  let smsType;
  let smsLength = 0;
  let smsCount = -1;
  let charCount = 0;
  let charsLeft = 0;
  let text = content;
  let isUnicode = false;
  let arrayUnicodeChar = [];

  for (let charPos = 0; charPos < text.length; charPos++) {
    switch (text[charPos]) {
      case '\n':
      case '[':
      case ']':
      case '\\':
      case '^':
      case '{':
      case '}':
      case '|':
      case '€':
        smsLength += 2;
        break;

      default:
        smsLength += 1;
    }

    if (
      (text.charCodeAt(charPos) > 127 && text[charPos] !== '€') ||
      checkIfUnicode(text[charPos])
    ) {
      arrayUnicodeChar = [...arrayUnicodeChar, text[charPos]];
      isUnicode = true;
    }
    charCount = charCount + 1;
  }

  if (isUnicode) {
    smsType = s.lengths.unicode;
  } else {
    smsType = s.lengths.ascii;
  }

  for (let sCount = 0; sCount < s.maxSmsNum; sCount++) {
    cutStrLength = smsType[sCount];
    if (smsLength <= smsType[sCount]) {
      smsCount = sCount + 1;
      charsLeft = smsType[sCount] - smsLength;
      break;
    }
  }

  if (s.cut) {
    text = text.substring(0, cutStrLength);
  }

  if (smsCount === -1) {
    smsCount = s.maxSmsNum;
    charsLeft = 0;
  }

  return { smsCount, charsLeft, arrayUnicodeChar, charCount };
};
